import { Grid } from "@mui/material";
import { ProductCard } from "components/ui";
import { useCatalogSettingContext } from "context/CatalogSettingContext";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import CatalogClientTimeSpentModal from "./CatalogClientTimeSpentModal";
import withReportData from "../../utils/withReportData";
import ReportDatas from "../../utils/ReportDatas";
import CatalogClinetSortModal from "./CatalogClinetSortModal";
import { useGetCatalogClientStylesReports } from "../hooks/useGetCatalogClientStylesReports";
import clientReportsAPIs from "../api/clientReportsAPIs";
import SortContext from "context/SortContext";
import { useGlobalContext } from "context/GlobalContext";
import { useGetCatalogAllClientEmployeeStylesReports } from "../hooks/useGetCatalogAllClientStyleReports";
import CatalogViewCartModal from "../../CatalogReport/componet/CatalogViewCartModal";
import CatalogClientViewCartModal from "./CatalogClientViewCartModal";

const catalogProductsReports = [
  {
    id: 1,
    bronze: "NS-00410",
    view: 23,
    cart: 20,
    removeCart: 3,
    clock: "00:15:23",
  },
  {
    id: 2,
    silver: "NS-00560",
    view: 26,
    cart: 15,
    removeCart: 6,
    clock: "00:20:23",
  },
  {
    id: 3,
    gold: "NS-00603",
    view: 30,
    cart: 10,
    removeCart: 8,
    clock: "00:10:23",
  },
];

const catalogProductsDetails = [
  {
    id: 1,
    bronze: "NS-00410",
    diamond: "500/1.495",
    weight: "6.59/6.25",
    labour: "X",
    date: "15/02/2022",
  },
  {
    id: 2,
    silver: "NS-00560",
    diamond: "300/0.995",
    weight: "9.09/8.05",
    labour: "R",
    date: "17/02/2022",
  },
  {
    id: 3,
    gold: "NS-00603",
    diamond: "400/1.095",
    weight: "10.59/9.25",
    labour: "H",
    date: "19/02/2022",
  },
];

const CatalogClientReportScreen = ({ btnTitles, setBtnTitles, reportData, setReportData, handleHideDetails, ...props }) => {
  const { timeSpentCatalogOpen, setTimeSpentCatalogOpen, sortModal, setSortModal, serarch, setSerarch, activeTable, setViewLinkModal, viewLinkModal } = useCatalogSettingContext();
  let location = useLocation();
  let companyName = new URLSearchParams(window?.location?.search).get("companyName");
  console.log("Company Name in Client Report Screen:", activeTable, companyName);
  let isIconsClickable = activeTable === "My Binny's";
  const { selectedSortValue, sortOptions, setSortOptions, setSelectedSortValue } = React.useContext(SortContext);
  const sort = sortOptions.find((item) => item.id == selectedSortValue);
  const { id, catalogClinetId } = useParams();
  const [productDetails, setProductDetails] = useState();
  const [viewCartType, setViewCartType] = useState("");

  const handleViewCartDetails = (data, icon) => {
    setViewLinkModal(true);
    setProductDetails(data);
    setViewCartType(icon);
  };

  let singleClientPayload = {
    catalogClinetId: catalogClinetId,
    catalogId: id,
    sortBy: sort?.sortBy,
    serarch: serarch || "",
    sortType: sort?.sortType,
  };

  let allClientPayload = {
    catalogClinetId: catalogClinetId,
    catalogId: id,
    sortBy: sort?.sortBy,
    serarch: serarch || "",
    sortType: sort?.sortType,
    companyName: companyName || "",
  };

  const singleClientQuery = useGetCatalogClientStylesReports(singleClientPayload, activeTable !== "My Binny's");

  const allClientQuery = useGetCatalogAllClientEmployeeStylesReports(allClientPayload, activeTable === "My Binny's");

  const { data, isLoading, fetchNextPage, hasNextPage, isError, isFetching, isFetchingNextPage, error } = activeTable === "My Binny's" ? allClientQuery : singleClientQuery;

  const { setFilterChangeCount, setDisplayCount, dynamicfilterCount, setDynamicFilterCount, setSearchResultCount, filterChangeCount } = useGlobalContext();

  const handleShowDetails = (_id) => {
    setBtnTitles((prev) => ({ ...prev, [_id]: "Hide Details" }));
  };

  useEffect(() => {
    if (serarch === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.pages[0]?.totalCount);
      // setFilterChangeDesignCount(data?.pages[0]?.totalDesginCount);
      setSearchResultCount(data?.pages[0]?.totalCount);
    } else {
      setSearchResultCount(data?.pages[0]?.totalCount);
      setFilterChangeCount(filterChangeCount);
      // setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      // setFilterChangeDesignCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  useEffect(() => {
    return () => {
      setSortOptions([]);
      setSelectedSortValue("");
      setSerarch("");
    };
  }, []);

  return (
    <ReportDatas
      {...props}
      isLoading={isLoading}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isError={isError}
      isFetching={isFetching}
      isFetchingNextPage={isFetchingNextPage}
      error={error}
      btnTitles={btnTitles}
      reportData={data || []}
      handleShowDetails={handleShowDetails}
      handleHideDetails={handleHideDetails}
      handleViewCartDetails={isIconsClickable ? handleViewCartDetails : undefined}
      timeSpentCatalogModal={!isLoading && <CatalogClientTimeSpentModal open={timeSpentCatalogOpen} setOpen={setTimeSpentCatalogOpen} />}
      sortCatalogModal={<CatalogClinetSortModal open={sortModal} setOpen={setSortModal} />}
      viewIconCatalogModal={<CatalogClientViewCartModal open={viewLinkModal} setOpen={setViewLinkModal} productDetails={productDetails} viewCartType={viewCartType} />}
    />
  );
};

export default withReportData(CatalogClientReportScreen, catalogProductsDetails, catalogProductsReports, "Client Report");
